import React, { useEffect, useRef, useState } from "react";
import { differenceInDays } from "date-fns/differenceInDays";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
  truncateFormat,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import * as XLSX from "xlsx";
import {
  Form,
  Card,
  Button,
  Dropdown,
  InputGroup,
  ProgressBar,
} from "react-bootstrap";
import {
  IconPaperclip,
  IconCircle,
  IconEdit,
  IconMailSpark,
  IconHistoryToggle,
  IconBox,
  IconRotateClockwise,
  IconMessageCircle,
  IconEye,
  IconSearch,
  IconLayoutListFilled,
  IconLayoutGridFilled,
  IconRefreshDot,
  IconSquareArrowRight,
  IconFilter,
  IconTir,
  IconListDetails,
  IconReportMoney,
  IconChevronDown,
  IconX,
  IconArrowsSort,
  IconFileTypeXls,
} from "@tabler/icons-react";
import moment from "moment";
import { shouldHideSubstatus } from "../../utils/_helpers";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import GetOrderHistoryDialog from "./GetOrderHistoryDialog";
import Product_Revistion_order from "./Product_Revistion_order";
import EmailQuoteDialogOrder from "./Email/EmailQuoteDialogOrder";
import EmailHistoryOrder from "./Email/EmailHistoryOrder";
import OrderKOorCustomerEmailDialog from "./Email/OrderKOorCustomerEmailDialog";
import ExcelDialogOrder from "./ExcelDialogOrder";
import View_DetailsLifecycle from "./ViewDetail/View_DetailsLifecycle";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import useIdleLogout from "../../hooks/useIdleLogout";
import { usePostHog } from "@posthog/react";
import Filters from "./FiltersModal/Filters";
import Loader from "../../components/Loader";
import axiosInstance from "../../api/axiosInstance";
import TableListingNew from "./TableListingNew";
import TableListing from "./TableListing";

const LifeCycleListing = () => {
  // State for the new dynamic data structure
  const [lifecycleData, setLifecycleData] = useState({});

  // Track pagination for each status and sub-status
  const [paginationState, setPaginationState] = useState({});

  // Track loading states for load more buttons
  const [loadingStates, setLoadingStates] = useState({});

  // Track if there's more data to load for each stage
  const [hasMoreData, setHasMoreData] = useState({});

  const [limit, setLimit] = useState(10);
  const [orderSku, setOrderSku] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [sortOption, setSortOption] = useState("recently_updated");
  const [viewType, setViewType] = useState(() => {
    return localStorage.getItem("viewType") || "general";
  });
  const [isListView, setIsListView] = useState(() => {
    const savedView = localStorage.getItem("isListView");
    return savedView ? JSON.parse(savedView) : false;
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const posthog = usePostHog();

  // Save ListView LocalStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("isListView", JSON.stringify(isListView));
  }, [isListView]);
  const handleListViewChange = (value) => {
    setIsListView(value);
    localStorage.setItem("isListView", JSON.stringify(value));
  };

  // Save view type to localStorage
  useEffect(() => {
    localStorage.setItem("viewType", viewType);
  }, [viewType]);

  // Status configuration with colors
  const statusConfig = {
    PENDING: {
      label: "Pending",
      color: "#F59F00",
      class: "pending_status",
    },
    "IN PROGRESS": {
      label: "In Progress",
      color: "#066FD1",
      class: "progress_status",
    },
    DELIVERED: {
      label: "Delivered",
      color: "#42ad9fff",
      class: "won_status",
    },
    PAID_CLOSED: {
      label: "Paid & Closed",
      color: "#06a159ff",
      class: "won_status",
    },
    LOST_CANCELLED: {
      label: "Lost/Cancelled",
      color: "#D63939",
      class: "closed_status",
    },
  };

  const SUBSTATUS_LABELS = {
    PENDING: "Pending",
    "PO-Pending": "PO Pending",
    "Pre-Payment-Pending": "Pre-Payment Pending",
    "IN PROGRESS": "In Progress",
    "In-Transit-to-Warehouse": "In Transit to Warehouse",
    "At-Warehouse": "At Warehouse",
    "Warehouse-Ready-to-Ship": "Warehouse Ready to Ship",
    "In-Transit-to-Customer": "Back Ordered / Partial Orders",
    DELIVERED: "Shipped",
    ARO: "AR Closed",
    "Post-Payment-Pending": "Post-Payment Pending",
    "Invoice-Pending": "Invoice Pending",
    "Invoice-Payment-Pending": "Invoice Payment Pending",
    PAID_CLOSED: "Paid & Closed",
    "Vendor-Bill-Pending": "Vendor Bill Pending",
    "Vendor-Payment-Pending": "Vendor Payment Pending",
  };

  const viewTypeMap = {
    general: {
      icon: <IconListDetails size={16} />,
      label: "General Lifecycle",
    },
    logistics: {
      icon: <IconTir size={16} />,
      label: "Logistics Lifecycle",
    },
    finance: {
      icon: <IconReportMoney size={16} />,
      label: "Finance Lifecycle",
    },
  };

  const sortOptionsMap = {
    recently_updated: {
      sort_by: "updated_at",
      sort_order: "desc",
      label: "Recently Updated",
    },
    created_date_closest: {
      sort_by: "published_date",
      sort_order: "desc",
      label: "Created date closest to now",
    },
    created_date_farthest: {
      sort_by: "published_date",
      sort_order: "asc",
      label: "Created date farthest from now",
    },
    due_date_closest: {
      sort_by: "estimated_date",
      sort_order: "desc",
      label: "Due date closest to now",
    },
    due_date_farthest: {
      sort_by: "estimated_date",
      sort_order: "asc",
      label: "Due date farthest from now",
    },
  };

  // Modal states
  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [isModalStatusOpen, setIsModalStatusOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isModalOpen, setIsModalOpen] = useState({ show: false });
  const [isHistoryOpen, setIsHistoryOpen] = useState({ show: false });
  const [isExcelOpen, setIsExcelOpen] = useState({ show: false });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    ORDERID: "",
    toEmail: "",
    toName: "",
  });

  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    order_id: "",
  });

  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    order_id: "",
  });

  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });

  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  
  const searchInputRef = useRef();
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [salesHeadFilter, setSalesHeadFilter] = useState("");
  const [contractFilter, setContractFilter] = useState("");
  const [orderTypeFilter, setOrderTypeFilter] = useState("");
  const [paymentTypeFilter, setPaymentTypeFilter] = useState("");
  const [stageFilter, setStageFilter] = useState("");
  const [subStatusesFilter, setSubStatusesFilter] = useState([]);
  const [vendorFilter, setVendorFilter] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [selectedProductsFilter, setSelectedProductsFilter] = useState([]);
  const [fulfillmentFrom, setFulfillmentFrom] = useState(null);
  const [fulfillmentTo, setFulfillmentTo] = useState(null);
  const [warehouseFrom, setWarehouseFrom] = useState(null);
  const [warehouseTo, setWarehouseTo] = useState(null);
  const [globalTotal, setGlobalTotal] = useState(0);
  const [filteredTotal, setFilteredTotal] = useState(0);
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isContentSearching, setIsContentSearching] = useState(false);
  const [openSubstatusDropdown, setOpenSubstatusDropdown] = useState(null);

  const filterBtnRef = useRef(null);

  // API hooks
  const { postData: fetchLifecycleData } = usePostRequest(
    API_ENDPOINTS.ORDER_LIST_NEW
  );

  const { postData: fetchLoadMoreData } = usePostRequest(
    API_ENDPOINTS.ORDER_LIST
  );

  const { postData: statusChange } = usePostRequest(
    API_ENDPOINTS.ORDER_STATUS
  );

  const { data: contractData, postData: fetchContract } = usePostRequest(
    API_ENDPOINTS.GET_CONTRACT
  );

  const { postData: getSteps } = usePostRequest(
    API_ENDPOINTS.GET_PENDING_STEPS
  );

  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS
  );

  const { postData: changeSubstatus } = usePostRequest(
    API_ENDPOINTS.ORDER_STATUS
  );

  useIdleLogout();

  // Helper function to generate a unique key for pagination tracking
  const generateStageKey = (statusKey, stageValue) => {
    return `${statusKey}_${stageValue}`;
  };

  const downloadExcel = async () => {
    try {
      const rawFilters = JSON.parse(
        localStorage.getItem("orderFilters") || "{}"
      );

      const filters = {};

      if (rawFilters.salesLead) filters.sales_lead = rawFilters.salesLead;
      if (rawFilters.contractVehicle)
        filters.contract_type_id = rawFilters.contractVehicle;
      if (rawFilters.orderType) filters.order_type = rawFilters.orderType;
      if (rawFilters.paymentType)
        filters.order_payment_type = rawFilters.paymentType;
      if (rawFilters.stage) filters.status = rawFilters.stage;
      if (rawFilters.subStatuses?.length)
        filters.sub_status = rawFilters.subStatuses;
      if (rawFilters.vendor) filters.vendor_id = rawFilters.vendor;
      if (rawFilters.selectedProducts?.length)
        filters.sku_ids = rawFilters.selectedProducts.map(
          (item) => item.sku_id
        );
      if (rawFilters.createdFrom)
        filters.created_date_from = rawFilters.createdFrom;
      if (rawFilters.createdTo) filters.created_date_to = rawFilters.createdTo;
      if (rawFilters.fulfillmentFrom)
        filters.actual_date_from = rawFilters.fulfillmentFrom;
      if (rawFilters.fulfillmentTo)
        filters.actual_date_to = rawFilters.fulfillmentTo;
      if (rawFilters.warehouseFrom)
        filters.estimated_date_from = rawFilters.warehouseFrom;
      if (rawFilters.warehouseTo)
        filters.estimated_date_to = rawFilters.warehouseTo;
      if (rawFilters.search) filters.search = rawFilters.search;

      const response = await axiosInstance.post(
        API_ENDPOINTS.ORDER_EXCEL_DOWNLOAD,
        filters,
        { responseType: "blob" }
      );

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let fileName = "orders.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  // Initialize pagination state for a stage
  const initializeStagePagination = (statusKey, stageValue) => {
    const key = generateStageKey(statusKey, stageValue);
    if (!paginationState[key]) {
      setPaginationState((prev) => ({
        ...prev,
        [key]: { page: 1 },
      }));
    }
  };

  // Handle load more for a specific stage (shared by board + list views)
  const handleLoadMore = async (statusKey, stage) => {
    const stageKey = generateStageKey(statusKey, stage.value);
    const currentPage = paginationState[stageKey]?.page || 1;
    const nextPage = currentPage + 1;

    setLoadingStates((prev) => ({ ...prev, [stageKey]: true }));

    const payload = {
      page: nextPage,
      limit,
      created_date_from: startDate
        ? moment(startDate).format("YYYY-MM-DD")
        : undefined,
      created_date_to: endDate
        ? moment(endDate).format("YYYY-MM-DD")
        : undefined,
      sales_lead: salesHeadFilter ? salesHeadFilter : undefined,
      search: search?.length > 0 ? search : undefined,
      contract_type_id: contractFilter?.length > 0 ? contractFilter : undefined,
      order_type: orderTypeFilter || undefined,
      order_payment_type: paymentTypeFilter || undefined,
      status: stageFilter || undefined,
      sub_status: subStatusesFilter?.length > 0 ? subStatusesFilter : undefined,
      vendor_id: vendorFilter || undefined,
      sku_ids:
        selectedProductsFilter?.length > 0
          ? selectedProductsFilter.map((p) => p.sku_id || p.id || p)
          : undefined,
      actual_date_from: fulfillmentFrom
        ? moment(fulfillmentFrom).format("YYYY-MM-DD")
        : undefined,
      actual_date_to: fulfillmentTo
        ? moment(fulfillmentTo).format("YYYY-MM-DD")
        : undefined,
      estimated_date_from: warehouseFrom
        ? moment(warehouseFrom).format("YYYY-MM-DD")
        : undefined,
      estimated_date_to: warehouseTo
        ? moment(warehouseTo).format("YYYY-MM-DD")
        : undefined,
      ...sortOptionsMap[sortOption],
      department: viewType,
    };

    if (stage.col_name === "status") {
      payload.status = stage.value;
    } else if (stage.col_name === "sub_status") {
      payload.sub_status = stage.value;
      payload.status = statusKey;
    }

    try {
      await fetchLoadMoreData(
        payload,
        (response) => {
          if (response?.data && Array.isArray(response.data)) {
            const newOrders = response.data;

            setLifecycleData((prevData) => {
              const newData = JSON.parse(JSON.stringify(prevData));
              if (newData[statusKey] && newData[statusKey].stage) {
                const stageIndex = newData[statusKey].stage.findIndex(
                  (s) =>
                    s.value === stage.value && s.col_name === stage.col_name
                );
                if (stageIndex !== -1) {
                  const existingData =
                    newData[statusKey].stage[stageIndex].data || [];
                  newData[statusKey].stage[stageIndex].data = [
                    ...existingData,
                    ...newOrders,
                  ];
                  if (newOrders.length < limit) {
                    setHasMoreData((prev) => ({
                      ...prev,
                      [stageKey]: false,
                    }));
                  }
                }
              }
              return newData;
            });

            setPaginationState((prev) => ({
              ...prev,
              [stageKey]: { page: nextPage },
            }));
          } else {
            setHasMoreData((prev) => ({ ...prev, [stageKey]: false }));
            toast.info("No more orders to load");
          }
        },
        (error) => {
          toast.error("Failed to load more data");
          console.error("Load more error:", error);
        }
      );
    } catch (error) {
      console.error("Load more error:", error);
      toast.error("Failed to load more data");
    } finally {
      setLoadingStates((prev) => ({ ...prev, [stageKey]: false }));
    }
  };

  const SUB_STATUS_TRANSITIONS = {
    PENDING: ["PO-Pending", "Pre-Payment-Pending"],
    "PO-Pending": ["PENDING", "Pre-Payment-Pending"],
    "Pre-Payment-Pending": ["PENDING", "PO-Pending"],
    "IN PROGRESS": [
      "In-Transit-to-Warehouse",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
    ],
    "In-Transit-to-Warehouse": [
      "IN PROGRESS",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
    ],
    "At-Warehouse": [
      "Warehouse-Ready-to-Ship",
      "In-Transit-to-Customer",
      "In-Transit-to-Warehouse",
      "IN PROGRESS",
    ],
    "Warehouse-Ready-to-Ship": [
      "In-Transit-to-Customer",
      "In-Transit-to-Warehouse",
      "IN PROGRESS",
    ],
    "In-Transit-to-Customer": [
      "In-Transit-to-Warehouse",
      "At-Warehouse",
      "Warehouse-Ready-to-Ship",
      "IN PROGRESS",
    ],
    DELIVERED: ["ARO", "Post-Payment-Pending", "Invoice-Payment-Pending","Invoice-Pending"],
    ARO: ["Post-Payment-Pending", "Invoice-Payment-Pending", "DELIVERED","Invoice-Pending"],
    "Post-Payment-Pending": ["Invoice-Payment-Pending", "DELIVERED", "ARO","Invoice-Pending"],
    "Invoice-Payment-Pending": ["DELIVERED", "ARO", "Post-Payment-Pending","Invoice-Pending"],
    "Invoice-Pending":["ARO","Post-Payment-Pending", "Invoice-Payment-Pending","DELIVERED"],
    PAID_CLOSED: ["Vendor-Bill-Pending", "Vendor-Payment-Pending",],
    "Vendor-Bill-Pending": ["Vendor-Payment-Pending", "PAID_CLOSED"],
    "Vendor-Payment-Pending": ["Vendor-Bill-Pending", "PAID_CLOSED"],
  };

  const SUBSTATUS_OPTIONS = {
    PENDING: [
      { value: "PENDING", label: "Pending", color: "#f4a100" },
      { value: "PO-Pending", label: "PO Pending", color: "#f4a100" },
      {
        value: "Pre-Payment-Pending",
        label: "Pre-Payment Pending",
        color: "#f97316",
      },
    ],
    "IN PROGRESS": [
      { value: "IN PROGRESS", label: "In Progress", color: "#3b82f6" },
      {
        value: "In-Transit-to-Warehouse",
        label: "In Transit to Warehouse",
        color: "#3b82f6",
      },
      { value: "At-Warehouse", label: "At Warehouse", color: "#8b5cf6" },
      {
        value: "Warehouse-Ready-to-Ship",
        label: "Warehouse Ready to Ship",
        color: "#6366f1",
      },
      {
        value: "In-Transit-to-Customer",
        label: "Back Ordered / Partial Orders",
        color: "#0ea5e9",
      },
    ],
    DELIVERED: [
      { value: "DELIVERED", label: "Shipped", color: "#10b981" },
      { value: "ARO", label: "AR Closed", color: "#10b981" },
      {
        value: "Post-Payment-Pending",
        label: "Post-Payment Pending",
        color: "#10b981",
      },
      {
        value: "Invoice-Pending",
        label: "Invoice Pending",
        color: "#14b8a6",
      },
      {
        value: "Invoice-Payment-Pending",
        label: "Invoice Payment Pending",
        color: "#14b8a6",
      },
    ],
    PAID_CLOSED: [
      { value: "PAID_CLOSED", label: "Paid & Closed", color: "#06a159" },
      {
        value: "Vendor-Bill-Pending",
        label: "Vendor Bill Pending",
        color: "#06a159",
      },
      {
        value: "Vendor-Payment-Pending",
        label: "Vendor Payment Pending",
        color: "#06a159",
      },
    ],
    LOST_CANCELLED: [],
  };

  const getSubstatusLabel = (status, subStatus) => {
    const options = SUBSTATUS_OPTIONS[status] || [];
    const match = options.find((opt) => opt.value === subStatus);
    return match?.label || subStatus;
  };

  const ChangeSubstatusHandler = (orderid, substatus) => {
    changeSubstatus(
      { order_id: orderid, order_status: substatus, is_next_clicked: false },
      (res) => {
        toast.success(res.message);
        triggerCardHighlight(orderid);
        setIsSearchClicked(true);
      },
      (error) => {
        toast.error(
          error.message || "An error occurred during Substatus Change."
        );
      }
    );
  };

  const openSubstatusModal = (orderId, substatus, oldSubstatus) => {
    const getDisplayLabel = (subStatus) => {
      if (subStatus === "DELIVERED") return "Shipped";
      else if (subStatus === "ARO") return "AR Closed";
      else if (subStatus === "In-Transit-to-Customer")
        return "Back Ordered / Partial Orders";
      return subStatus
        ?.replace(/[-_]+/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (l) => l.toUpperCase());
    };

    const displaySubstatus = getDisplayLabel(substatus);
    const displayOldSubstatus = getDisplayLabel(oldSubstatus);

    setIsModalStatusOpen({
      show: true,
      action: "Change",
      message: `Are you sure you want to Change Substatus From "${displayOldSubstatus}" To "${displaySubstatus}"?`,
      onConfirm: () => ChangeSubstatusHandler(orderId, substatus),
      title: "Change Substatus",
      icon: <IconRefreshDot stroke={1} />,
      type: "success",
    });
  };

  // Close substatus dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      if (openSubstatusDropdown) {
        setOpenSubstatusDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [openSubstatusDropdown]);

  // Helper functions
  function getProgressPercentage(cardData) {
    if (!Array.isArray(cardData) || cardData.length === 0) {
      return 0;
    }
    const activeCards = cardData.filter((item) => !item.is_deleted);
    const totalCards = activeCards.length;
    const completedCards = activeCards.filter(
      (item) => item.check_status
    ).length;
    const progress = Math.round((completedCards / totalCards) * 100);
    return progress;
  }

  const triggerCardHighlight = (orderId) => {
    setHighlightedOrders((prev) => [...prev, orderId]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== orderId));
    }, 3000);
  };

  const handleORDERRVERSION_OPEN = (e, order) => {
    e.preventDefault();
    setOrderSku(order);
    setIsModalOpen({ show: true });
  };

  
  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
    });
    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.order_id}`;
    window.history.pushState(null, "", newUrl);
  };


  const getOverdueClass = (dateString) => {
    if (!dateString) return "";
    const estimatedDate = new Date(dateString);
    const today = new Date();
    estimatedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const daysOverdue = Math.floor(
      (today - estimatedDate) / (1000 * 60 * 60 * 24)
    );

    if (daysOverdue >= 21) return "bg-forred";
    if (daysOverdue >= 10) return "bg-fororange";
    if (daysOverdue >= 2) return "bg-overdate";
  };

  const getDueDateClass = (dateString) => {
    if (!dateString) return "";
    const estimatedDate = new Date(dateString);
    const today = new Date();
    estimatedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const daysDifference = Math.floor(
      (estimatedDate - today) / (1000 * 60 * 60 * 24)
    );
    if (daysDifference < 0) return "text-danger";
    if (daysDifference <= 7) return "text-warning";
    return "";
  };

  const handleSearch = () => {
    const searchValue = searchInput.trim();
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }

    setIsContentSearching(true);
    setSearch(searchValue);
    updateStoredFilter("search", searchValue);
    setIsInitialLoad(false);
    setIsSearchClicked(true);

    setPaginationState({});
    setHasMoreData({});
  };

  const handleClearFilter = () => {
    setSalesHeadFilter("");
    setContractFilter("");
    setSelectedStatus([]);
    setSearch("");
    setSearchInput("");
    setStartDate(null);
    setEndDate(null);
    setSortOption("recently_updated");
    setViewType("general");
    setOrderTypeFilter("");
    setPaymentTypeFilter("");
    setStageFilter("");
    setSubStatusesFilter([]);
    setVendorFilter("");
    setVendorName("");
    setSelectedProductsFilter([]);
    setFulfillmentFrom(null);
    setFulfillmentTo(null);
    setWarehouseFrom(null);
    setWarehouseTo(null);

    setIsContentSearching(true);
    setIsInitialLoad(true);
    setIsSearchClicked(true);

    setPaginationState({});
    setHasMoreData({});

    localStorage.removeItem("orderFilters");
  };

  const handleSortChange = (sortKey) => {
    setSortOption(sortKey);
    setLifecycleData({});
    setIsContentSearching(true);
    setIsInitialLoad(false);
    setIsSearchClicked(true);

    setPaginationState({});
    setHasMoreData({});
  };

  const handleViewChange = (view) => {
    setViewType(view);
    setLifecycleData({});
    setIsContentSearching(true);
    setIsInitialLoad(false);
    setIsSearchClicked(true);

    setPaginationState({});
    setHasMoreData({});
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    if (response.order_status === "PAID_CLOSED") {
      posthog.capture("order_moved_paid&closed", {
        moved_by: user?.email,
        order_id: response?.order_id,
      });
    }
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const ChangeStatusHandler = (orderid, status) => {
    statusChange(
      { order_id: orderid, order_status: status, is_next_clicked: true },
      (res) => {
        onStatusSuccess(res);
        triggerCardHighlight(orderid);
        setIsSearchClicked(true);
      },
      onStatusError
    );
  };

  const STATUS_FLOW_ORDER = [
    "PENDING",
    "IN PROGRESS",
    "DELIVERED",
    "PAID_CLOSED",
    "LOST_CANCELLED",
  ];

  const getNextStage = (currentStage) => {
    const currentIndex = STATUS_FLOW_ORDER.indexOf(currentStage);
    if (currentIndex === -1 || currentIndex === STATUS_FLOW_ORDER.length - 1) {
      return null;
    }
    return STATUS_FLOW_ORDER[currentIndex + 1];
  };

  const openModalStatusChange = (Orderid, status, Old_Status) => {
    const getDisplayStatus = (stat) => {
      if (stat === "DELIVERED") return "Shipped";
      return stat
        ?.replace(/[-_]+/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (l) => l.toUpperCase());
    };

    const displayStatus = getDisplayStatus(status);
    const displayOldStatus = getDisplayStatus(Old_Status);

    let modalMessage = `Are you sure you want to Change Status From "${displayOldStatus}" To "${displayStatus}"?`;

    if (
      status.toLowerCase() === "shipped" ||
      status.toLowerCase() === "reached_warehouse" ||
      status.toLowerCase() === "delivered" ||
      status.toLowerCase() === "in progress" ||
      status.toLowerCase() === "paid_closed"
    ) {
      getSteps(
        { order_id: Orderid, order_status: status },
        (response) => {
          const steps = response?.data || [];

          if (steps.length > 0) {
            const stepList = steps
              .map((step) => `<li class="list-group-item">${step.name}</li>`)
              .join("");

            modalMessage += `<br /><br />
              <span>
                Some Chain of Custody steps are incomplete. Do you want to mark them as completed and proceed?
                You can <a href="/aspettoportal/frontend/edit-order/${Orderid}" target="_blank" class="text-primary">Edit Order</a> from here.
              </span>
              <br/>
              <ul class="list-group mt-3">${stepList}</ul>`;
          }

          setIsModalStatusOpen({
            show: true,
            action: "Change",
            message: modalMessage,
            onConfirm: () => ChangeStatusHandler(Orderid, status),
            title: "Change Status",
            icon: <IconRefreshDot stroke={1} />,
            type: "success",
          });
        },
        () => {
          toast.error("Failed to fetch pending steps.");
        }
      );
      return;
    }

    setIsModalStatusOpen({
      show: true,
      action: "Change",
      message: modalMessage,
      onConfirm: () => ChangeStatusHandler(Orderid, status),
      title: "Change Status",
      icon: <IconRefreshDot stroke={1} />,
      type: "success",
    });
  };

  // Fetch lookups
  useEffect(() => {
    const fetchData = async () => {
      await fetchRfq({ module_type: "ORDER" });
      await fetchContract();
    };
    fetchData();
  }, []);

  // Restore saved filters
  useEffect(() => {
    const savedFilters = localStorage.getItem("orderFilters");

    if (savedFilters) {
      const filters = JSON.parse(savedFilters);

      setSearchInput(filters.search || "");
      setSearch(filters.search || "");
      setSalesHeadFilter(filters.salesLead || "");
      setContractFilter(filters.contractVehicle || "");
      setOrderTypeFilter(filters.orderType || "");
      setPaymentTypeFilter(filters.paymentType || "");
      setStageFilter(filters.stage || "");
      setSubStatusesFilter(filters.subStatuses || []);
      setVendorFilter(filters.vendor || "");
      setVendorName(filters.vendor_name || "");
      setSelectedProductsFilter(filters.selectedProducts || []);
      setStartDate(
        filters.createdFrom
          ? moment(filters.createdFrom).format("YYYY-MM-DD")
          : undefined
      );
      setEndDate(
        filters.createdTo
          ? moment(filters.createdTo).format("YYYY-MM-DD")
          : undefined
      );
      setFulfillmentFrom(
        filters.fulfillmentFrom
          ? moment(filters.fulfillmentFrom).format("YYYY-MM-DD")
          : undefined
      );
      setFulfillmentTo(
        filters.fulfillmentTo
          ? moment(filters.fulfillmentTo).format("YYYY-MM-DD")
          : undefined
      );
      setWarehouseFrom(
        filters.warehouseFrom
          ? moment(filters.warehouseFrom).format("YYYY-MM-DD")
          : undefined
      );
      setWarehouseTo(
        filters.warehouseTo
          ? moment(filters.warehouseTo).format("YYYY-MM-DD")
          : undefined
      );

      setIsSearchClicked(true);
    } else {
      setIsSearchClicked(true);
    }
  }, []);

  // Main fetch — shared data source for BOTH board and list views
  useEffect(() => {
    if (isSearchClicked || isViewOpen.isStatusUpdate) {
      const payload = {
        page: 1,
        limit,
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        sales_lead: salesHeadFilter ? salesHeadFilter : undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        status:
          stageFilter ||
          (selectedStatus.length > 0 ? selectedStatus : undefined),
        sub_status:
          subStatusesFilter?.length > 0 ? subStatusesFilter : undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter?.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id || p.id || p)
            : undefined,
        actual_date_from: fulfillmentFrom
          ? moment(fulfillmentFrom).format("YYYY-MM-DD")
          : undefined,
        actual_date_to: fulfillmentTo
          ? moment(fulfillmentTo).format("YYYY-MM-DD")
          : undefined,
        estimated_date_from: warehouseFrom
          ? moment(warehouseFrom).format("YYYY-MM-DD")
          : undefined,
        estimated_date_to: warehouseTo
          ? moment(warehouseTo).format("YYYY-MM-DD")
          : undefined,
        ...sortOptionsMap[sortOption],
        department: viewType,
      };

      fetchLifecycleData(
        payload,
        (response) => {
          if (response?.data) {
            setLifecycleData(response.data);

            const isActivelyFilteredNow = !!(
              search ||
              salesHeadFilter ||
              contractFilter ||
              orderTypeFilter ||
              paymentTypeFilter ||
              stageFilter ||
              (subStatusesFilter && subStatusesFilter.length > 0) ||
              vendorFilter ||
              (selectedProductsFilter && selectedProductsFilter.length > 0) ||
              startDate ||
              endDate
            );

            const currentSum = Object.values(response.data).reduce(
              (acc, s) =>
                acc + (s.stage?.reduce((a, st) => a + (st.total || 0), 0) || 0),
              0
            );

            if (response.overall_total_orders !== undefined) {
              setGlobalTotal(response.overall_total_orders);
            } else if (isInitialLoad || !isActivelyFilteredNow) {
              setGlobalTotal(currentSum);
            }

            if (response.filtered_total_orders !== undefined) {
              setFilteredTotal(response.filtered_total_orders);
            } else {
              setFilteredTotal(currentSum);
            }

            // Initialize pagination state and hasMoreData for all stages
            Object.entries(response.data).forEach(([statusKey, statusData]) => {
              if (statusData.stage) {
                statusData.stage.forEach((stage) => {
                  const stageKey = generateStageKey(statusKey, stage.value);
                  initializeStagePagination(statusKey, stage.value);
                  setHasMoreData((prev) => ({
                    ...prev,
                    [stageKey]: (stage.data?.length || 0) >= limit,
                  }));
                });
              }
            });
          }
          setIsContentSearching(false);
          setIsSearchClicked(false);
        },
        () => {
          toast.error("Failed to fetch lifecycle data");
          setIsContentSearching(false);
          setIsSearchClicked(false);
        }
      );
    }
  }, [isSearchClicked, isViewOpen.isStatusUpdate]);

  // local storage update
  const updateStoredFilter = (key, value) => {
    const filters = JSON.parse(localStorage.getItem("orderFilters") || "{}");
    filters[key] = value;
    localStorage.setItem("orderFilters", JSON.stringify(filters));
  };

  // Render a single order card (board view)
  const renderOrderCard = (row, statusKey, subStatusValue) => {
    const overdueClass = getOverdueClass(row?.estimated_date);
    const statusStyle = statusConfig[statusKey];
    return (
      <Card
        className={`status_item_card ${overdueClass} ${highlightedOrders.includes(row.order_id)
          ? `card-highlight ${statusStyle?.class}`
          : ""
          }`}
        key={row.invoice_no}
        onClick={() => handleViewClick(row)}
        style={{ cursor: "pointer" }}
      >
        <Card.Body>
          <div className="rfq_card_row">
            <div className="rfq_item_card">
              <div className="value_card d-flex gap-2 align-items-center">
                Order ID:{" "}
                <p
                  className="label_card listing_label"
                  style={{ color: statusStyle?.color }}
                >
                  {row.order_id}
                </p>
              </div>
            </div>
          </div>

          <div className="rfq_substatus">
            <div
              className="rfq_substatus_item"
              style={{ position: "relative" }}
            >
              <span>Stage Status: </span>{" "}
              {SUBSTATUS_OPTIONS[row?.status]?.length > 0 &&
                row?.status !== "LOST_CANCELLED" ? (
                <div
                  className="status_dropdown"
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <button
                    className="btn btn-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenSubstatusDropdown(
                        openSubstatusDropdown === row.order_id
                          ? null
                          : row.order_id
                      );
                    }}
                    style={{
                      backgroundColor:
                        SUBSTATUS_OPTIONS[row?.status]?.find(
                          (opt) => opt.value === row?.sub_status
                        )?.color || "#6c757d",
                      color: "#fff",
                    }}
                  >
                    {getSubstatusLabel(row?.status, row?.sub_status)}
                    <IconChevronDown size={14} />
                  </button>
                  {openSubstatusDropdown === row.order_id && (
                    <div
                      className="status_dropdown_select"
                      style={{
                        position: "absolute",
                        zIndex: 1000,
                        top: "100%",
                        left: 0,
                        minWidth: "180px",
                        background: "#fff",
                        borderRadius: "6px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
                        overflow: "hidden",
                      }}
                    >
                      {SUBSTATUS_OPTIONS[row?.status]
                        .filter((option) => {
                          const allowedSubstatuses =
                            SUB_STATUS_TRANSITIONS[
                            row?.sub_status || row?.status
                            ] || [];
                          return (
                            allowedSubstatuses.includes(option.value) &&
                            !shouldHideSubstatus(row, option.value)
                          );
                        })
                        .map((option) => (
                          <div
                            className="status_options"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              openSubstatusModal(
                                row.order_id,
                                option.value,
                                row.sub_status
                              );
                              setOpenSubstatusDropdown(null);
                            }}
                            style={{
                              backgroundColor: option.color + "20",
                              cursor: "pointer",
                              padding: "8px 12px",
                              fontSize: "13px",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              option.color + "33")
                            }
                            onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              option.color + "20")
                            }
                          >
                            {option.label}
                          </div>
                        ))}
                      {SUBSTATUS_OPTIONS[row?.status].filter((option) => {
                        const allowedSubstatuses =
                          SUB_STATUS_TRANSITIONS[
                          row?.sub_status || row?.status
                          ] || [];
                        return allowedSubstatuses.includes(option.value);
                      }).length === 0 && (
                          <div
                            style={{
                              padding: "8px 12px",
                              fontSize: "13px",
                              color: "#999",
                            }}
                          >
                            No transitions available
                          </div>
                        )}
                    </div>
                  )}
                </div>
              ) : (
                <p className="label_card listing_label">
                  {row?.sub_status
                    ?.replace(/[-_]+/g, " ")
                    .toLowerCase()
                    .replace(/\b\w/g, (l) => l.toUpperCase())}
                </p>
              )}
            </div>
          </div>

          <div className="rfq_card_row">
            <div className="rfq_item_card">
              <div className="value_card">Sales Lead</div>
              <p className="label_card">{row?.sales_lead_name}</p>
            </div>
            <div className="rfq_item_card">
              <div className="value_card">Contract Vehicle</div>
              <p className="label_card">{row?.ContractType?.name}</p>
            </div>
          </div>

          <div className="rfq_card_row">
            <div className="rfq_item_card">
              <div className="value_card">Payment Type</div>
              <p className="label_card text-capitalize">
                {row?.order_payment_type}
              </p>
            </div>
            <div className="rfq_item_card">
              <div className="value_card">Due Date</div>
              <p
                className={`label_card ${getDueDateClass(row?.estimated_date)}`}
              >
                {moment(row?.estimated_date).format("MM/DD/YYYY")}
              </p>
            </div>
          </div>

          <div className="rfq_card_row">
            <div className="rfq_item_card">
              <div className="value_card">Type</div>
              <p className="label_card">
                {{
                  DS: "Dropship",
                  CRK: "Consolidate / Repack",
                  M: "Manufacturing",
                  KIT: "Kit",
                  S: "Stock",
                }[row?.order_type] ||
                  row?.order_type ||
                  "N/A"}
              </p>
            </div>
            <div className="rfq_item_card">
              <div className="value_card">Total Price:</div>
              <p className="label_card">
                <strong className="amt_bold">
                  ${row?.total_cost_after_margin_sales}
                </strong>
              </p>
            </div>
          </div>

          <div className="button-groups mb-3">
            <div className="badge_btn">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/edit-order/${row?.order_id}`);
                }}
              >
                <IconEdit width={24} />
              </span>
              <b> Edit </b>
            </div>

            <div className="badge_btn">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewClick(row);
                }}
              >
                <IconEye size={24} />
              </span>
              <b> View </b>
            </div>

            <div className="badge_btn">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  handleORDERRVERSION_OPEN(e, row.order_id);
                }}
              >
                <IconHistoryToggle size={24} />
              </span>
              <b>Changes</b>
            </div>

            {row?.status !== "PAID_CLOSED" &&
              row?.status !== "LOST_CANCELLED" && (
                <div className="badge_btn">
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      openModalStatusChange(
                        row.order_id,
                        getNextStage(row?.status),
                        row?.status
                      );
                    }}
                  >
                    <IconSquareArrowRight size={24} />
                  </span>
                  <b>Next Stage</b>
                </div>
              )}

            <div className="badge_btn">
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setIsEmailHistoryOpen({
                    show: true,
                    order_id: row.order_id,
                  });
                }}
              >
                <IconMailSpark size={24} />
              </span>
              <b>Email</b>
            </div>
          </div>

          <div className="ftr_card_box d-block">
            <div className="w-100">
              <div className="d-flex gap-1">
                <strong>Up Next:</strong>
                <p className="mb-1">{row?.coc_next_step}</p>
              </div>
              <ProgressBar
                variant="warning"
                now={getProgressPercentage(row?.OrderChainOfCustodies)}
                style={{ height: "6px", width: "100%" }}
              />
            </div>

            <div className="edit_flex_row">
              <div className="rfq_lis_short">
                <span>
                  <IconBox stroke={1} />
                  {row.product_count}
                </span>
                <span>
                  <IconPaperclip stroke={1} />
                  {row.attachment_count}
                </span>
                <span>
                  <IconMessageCircle stroke={1} />
                  {row.notes_count}
                </span>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  // Render sub-columns for a stage (board view)
  const renderSubColumns = (stages, statusKey) => {
    return stages.map((stage, stageIndex) => {
      const stageKey = generateStageKey(statusKey, stage.value);
      const isLoading = loadingStates[stageKey] || false;
      const hasMore = hasMoreData[stageKey] !== false;

      return (
        <div className="column" key={`substatus-${stageIndex}`}>
          {stage.col_name === "sub_status" && (
            <div className="sub-header">
              {stage?.display_name}{" "}
              <span className="sub_status_counts">{stage?.total}</span>{" "}
            </div>
          )}
          <div className="status_row_scroll lifecycle_row_scroll">
            {stage.data && stage.data.length > 0 ? (
              <>
                {stage.data.map((row) =>
                  renderOrderCard(
                    row,
                    stage.col_name === "status" ? stage.value : statusKey,
                    stage.value
                  )
                )}

                {hasMore && stage.data.length >= limit && (
                  <div className="text-center mt-2">
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => handleLoadMore(statusKey, stage)}
                      disabled={isLoading}
                    >
                      <IconRotateClockwise size={18} />
                      {isLoading ? "Loading..." : "Load More"}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <Card className="status_item_card">
                <Card.Body>No data found.</Card.Body>
              </Card>
            )}
          </div>
        </div>
      );
    });
  };

  // Render main stages dynamically (board view)
  const renderLifecycleStages = () => {
    if (!lifecycleData || Object.keys(lifecycleData).length === 0) {
      return (
        <Card className="status_item_card">
          <Card.Body>Loading...</Card.Body>
        </Card>
      );
    }

    return Object.entries(lifecycleData).map(([statusKey, statusData]) => {
      const statusStyle = statusConfig[statusKey];
      const totalCount = statusData.stage?.reduce(
        (sum, stage) => sum + (stage.total || 0),
        0
      );

      return (
        <div className="main-stage" key={statusKey}>
          <div className={`status_item_box ${statusStyle?.class}`}>
            <div className="status-heading">
              <IconCircle size={18} stroke={5} color={statusStyle?.color} />
              <span className="fw-bold">{statusData.display_name}</span>
            </div>
            <span
              className="status_count"
              style={{ color: statusStyle?.color }}
            >
              {totalCount || 0}
            </span>
          </div>

          <div className="sub-columns-wrapper">
            {statusData.stage && renderSubColumns(statusData.stage, statusKey)}
          </div>
        </div>
      );
    });
  };

  const fmtDate = (d) => (d ? moment(d).format("YYYY-MM-DD") : "…");

  const activeChips = [];
  if (salesHeadFilter)
    activeChips.push({
      key: "salesLead",
      labelKey: "Sales Lead",
      labelValue: salesHeadFilter,
      clear: () => {
        updateStoredFilter("salesLead", "");
        setSalesHeadFilter("");
        setIsSearchClicked(true);
      },
    });
  if (contractFilter) {
    const cv =
      contractData?.data?.find((v) => String(v.id) === String(contractFilter))
        ?.name || contractFilter;
    activeChips.push({
      key: "contract",
      labelKey: "Contract Vehicle",
      labelValue: cv,
      clear: () => {
        updateStoredFilter("contractVehicle", "");
        setContractFilter("");
        setIsSearchClicked(true);
      },
    });
  }
  if (startDate || endDate)
    activeChips.push({
      key: "createdDate",
      labelKey: "Created Date",
      labelValue: `${fmtDate(startDate)} → ${fmtDate(endDate)}`,
      clear: () => {
        updateStoredFilter("createdFrom", "");
        updateStoredFilter("createdTo", "");
        setStartDate(null);
        setEndDate(null);
        setIsSearchClicked(true);
      },
    });
  if (search)
    activeChips.push({
      key: "search",
      labelKey: "Search",
      labelValue: search,
      clear: () => {
        updateStoredFilter("search", "");
        setSearch("");
        setSearchInput("");
        if (searchInputRef.current) searchInputRef.current.value = "";
        setIsSearchClicked(true);
      },
    });
  if (orderTypeFilter)
    activeChips.push({
      key: "orderType",
      labelKey: "Order Type",
      labelValue: orderTypeFilter,
      clear: () => {
        updateStoredFilter("orderType", "");
        setOrderTypeFilter("");
        setIsSearchClicked(true);
      },
    });
  if (paymentTypeFilter)
    activeChips.push({
      key: "paymentType",
      labelKey: "Payment Type",
      labelValue: paymentTypeFilter,
      clear: () => {
        updateStoredFilter("paymentType", "");
        setPaymentTypeFilter("");
        setIsSearchClicked(true);
      },
    });
  if (stageFilter)
    activeChips.push({
      key: "stage",
      labelKey: "Stage",
      labelValue: stageFilter,
      clear: () => {
        updateStoredFilter("stage", "");
        setStageFilter("");
        setSubStatusesFilter([]);
        setIsSearchClicked(true);
      },
    });
  if (subStatusesFilter?.length > 0)
    activeChips.push({
      key: "subStatuses",
      labelKey: "Substatus",
      labelValue: subStatusesFilter
        .map((s) => SUBSTATUS_LABELS[s] || s)
        .join(", "),
      clear: () => {
        updateStoredFilter("subStatuses", []);
        setSubStatusesFilter([]);
        setIsSearchClicked(true);
      },
    });
  if (vendorFilter)
    activeChips.push({
      key: "vendor",
      labelKey: "Vendor",
      labelValue: vendorName,
      clear: () => {
        updateStoredFilter("vendor", "");
        updateStoredFilter("vendor_name", "");
        setVendorFilter("");
        setIsSearchClicked(true);
      },
    });
  if (selectedProductsFilter?.length > 0)
    activeChips.push({
      key: "products",
      labelKey: "Products",
      labelValue: selectedProductsFilter
        .map((product) => product.sku_display_name)
        .join(", "),
      clear: () => {
        updateStoredFilter("selectedProducts", []);
        setSelectedProductsFilter([]);
        setIsSearchClicked(true);
      },
    });
  if (fulfillmentFrom || fulfillmentTo)
    activeChips.push({
      key: "fulfillmentDate",
      labelKey: "Fulfillment Date",
      labelValue: `${fmtDate(fulfillmentFrom)} → ${fmtDate(fulfillmentTo)}`,
      clear: () => {
        updateStoredFilter("fulfillmentFrom", "");
        updateStoredFilter("fulfillmentTo", "");
        setFulfillmentFrom(null);
        setFulfillmentTo(null);
        setIsSearchClicked(true);
      },
    });
  if (warehouseFrom || warehouseTo)
    activeChips.push({
      key: "warehouseDate",
      labelKey: "Warehouse Date",
      labelValue: `${fmtDate(warehouseFrom)} → ${fmtDate(warehouseTo)}`,
      clear: () => {
        updateStoredFilter("warehouseFrom", "");
        updateStoredFilter("warehouseTo", "");
        setWarehouseFrom(null);
        setWarehouseTo(null);
        setIsSearchClicked(true);
      },
    });
  const filterCount = activeChips.length;

  return (
    <>
      {isContentSearching && <Loader />}

      {/* Modals */}
      <ComanConfirmationModal
        show={isModalStatusOpen.show}
        onHide={() => {
          setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
        }}
        title={isModalStatusOpen.title}
        message={isModalStatusOpen.message}
        onConfirm={isModalStatusOpen.onConfirm}
        icon={isModalStatusOpen.icon}
        type={isModalStatusOpen.type}
      />

      {isHistoryOpen.show && (
        <GetOrderHistoryDialog
          orderSku={orderSku}
          show={isHistoryOpen.show}
          setShow={setIsHistoryOpen}
        />
      )}

      {isModalOpen.show && (
        <Product_Revistion_order
          orderSku={orderSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}

      {isEmailQuoteOpen.show && (
        <EmailQuoteDialogOrder
          username={user.username}
          show={isEmailQuoteOpen.show}
          order_id={isEmailQuoteOpen.order_id}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {isEmailHistoryOpen.show && (
        <EmailHistoryOrder
          username={user.username}
          show={isEmailHistoryOpen.show}
          order_id={isEmailHistoryOpen.order_id}
          setShow={setIsEmailHistoryOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      <View_DetailsLifecycle
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
        triggerCardHighlight={triggerCardHighlight}
      />

      {isEmaillOpen.show && (
        <OrderKOorCustomerEmailDialog
          pagetitle={isEmaillOpen.title}
          toEmail={isEmaillOpen.toEmail}
          toName={isEmaillOpen.toName}
          ORDERID={isEmaillOpen.ORDERID}
          show={isEmaillOpen.show}
          skuData={isEmaillOpen.skuData}
          row={isEmaillOpen.row}
          defaultSubject={isEmaillOpen.defaultSubject}
          Quote_No={isEmaillOpen.Quote_No}
          setShow={setIsEmaillOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {isExcelOpen.show && (
        <ExcelDialogOrder
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={() => {
            setIsExcelOpen({ show: false });
          }}
        />
      )}

      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen({ ...isSuccsessModalOpen, show: false })
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />

      {/* Header + Board/List toggle */}
      <div className="page-header d-print-none mb-3">
        <div className="row align-items-center justify-content-between">
          <div className="col">
            <h2 className="page-title">Order</h2>
          </div>
          <div className="col-auto">
            <div
              className="view-toggle d-inline-flex align-items-center gap-1 board-list-toggle"
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
                padding: "3px",
              }}
            >
              <Button
                onClick={() => handleListViewChange(false)}
                className="d-flex align-items-center gap-1 border-0"
                style={{
                  backgroundColor: !isListView ? "#fe6338" : "transparent",
                  color: !isListView ? "#fff" : "#6c757d",
                  boxShadow: "none",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "13px",
                  padding: "8px 10px",
                  lineHeight: 1.2,
                  minWidth: "auto",
                }}
              >
                <IconLayoutGridFilled size={14} /> Board
              </Button>
              <Button
                onClick={() => handleListViewChange(true)}
                className="d-flex align-items-center gap-1 border-0"
                style={{
                  backgroundColor: isListView ? "#fe6338" : "transparent",
                  color: isListView ? "#fff" : "#6c757d",
                  boxShadow: "none",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "13px",
                  padding: "8px 10px",
                  lineHeight: 1.2,
                  minWidth: "auto",
                }}
              >
                <IconLayoutListFilled size={14} /> List
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Shared filter bar — applies to BOTH views */}
      <Card className="mb-2 shadow-sm">
        <Card.Body className="p-3">
          <Form
            className="d-flex align-items-center gap-4 position-relative"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <InputGroup>
              <Form.Control
                ref={searchInputRef}
                className="bg-light shadow-none"
                placeholder="Search anything..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                autoComplete="off"
              />
              <InputGroup.Text className="bg-white border-start-0">
                <IconSearch stroke={2} />
              </InputGroup.Text>
            </InputGroup>

            <div className="d-flex align-items-center gap-2 border_filter">
              <Button
                ref={filterBtnRef}
                className="filter-btn"
                onClick={() => setShowFiltersModal((p) => !p)}
              >
                <IconFilter size={16} />
                <span>Filters</span>
                {filterCount > 0 && (
                  <span className="filter-count-badge ms-1">
                    {filterCount}
                  </span>
                )}
              </Button>

              <Dropdown onSelect={handleSortChange}>
                <Dropdown.Toggle className="filter-btn">
                  <IconArrowsSort size={16} />
                  Sort:{" "}
                  {sortOptionsMap[sortOption]?.label || "Recently Updated"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="recently_updated">
                    Recently updated
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="created_date_closest">
                    Created date closest to now
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="created_date_farthest">
                    Created date farthest from now
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="due_date_closest">
                    Due date closest to now
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="due_date_farthest">
                    Due date farthest from now
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="d-flex align-items-center justify-content-between gap-3">
              <Dropdown onSelect={handleViewChange}>
                <Dropdown.Toggle variant="light" className="filter-btn">
                  {viewType ? (
                    <span className="d-inline-flex align-items-center gap-2">
                      {viewTypeMap[viewType].icon}
                      {viewTypeMap[viewType].label}
                    </span>
                  ) : (
                    "View Type"
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="general">
                    General Lifecycle
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="logistics">
                    Logistics Lifecycle
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="finance">
                    Finance Lifecycle
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="d-flex align-items-center gap-2 border_filter">
              <Button variant="warning" onClick={handleSearch}>
                <IconSearch size={16} /> Search
              </Button>

              <Button
                variant="success"
                onClick={downloadExcel}
                className="d-flex align-items-center gap-1"
              >
                <IconFileTypeXls size={16} /> XLS Report
              </Button>
            </div>

            <Filters
              show={showFiltersModal}
              onHide={() => setShowFiltersModal(false)}
              anchorRef={filterBtnRef}
              initialValues={{
                salesLead: salesHeadFilter,
                contractVehicle: contractFilter,
                createdFrom: startDate,
                createdTo: endDate,
                orderType: orderTypeFilter,
                paymentType: paymentTypeFilter,
                stage: stageFilter,
                subStatuses: subStatusesFilter,
                vendor: vendorFilter,
                selectedProducts: selectedProductsFilter,
                fulfillmentFrom: fulfillmentFrom,
                fulfillmentTo: fulfillmentTo,
                warehouseFrom: warehouseFrom,
                warehouseTo: warehouseTo,
              }}
              salesHeadData={SalesHead?.data || []}
              contractData={contractData?.data || []}
              matchCount={filteredTotal}
              totalCount={globalTotal}
              onApply={(values) => {
                setSalesHeadFilter(values.salesLead || "");
                setContractFilter(values.contractVehicle || "");
                setStartDate(values.createdFrom || null);
                setEndDate(values.createdTo || null);
                setOrderTypeFilter(values.orderType || "");
                setPaymentTypeFilter(values.paymentType || "");
                setStageFilter(values.stage || "");
                setSubStatusesFilter(values.subStatuses || []);
                setVendorFilter(values.vendor || "");
                setVendorName(values.vendor_name || "");
                setSelectedProductsFilter(values.selectedProducts || []);
                setFulfillmentFrom(values.fulfillmentFrom || null);
                setFulfillmentTo(values.fulfillmentTo || null);
                setWarehouseFrom(values.warehouseFrom || null);
                setWarehouseTo(values.warehouseTo || null);
                setIsContentSearching(true);
                setIsSearchClicked(true);
              }}
            />
          </Form>
        </Card.Body>
      </Card>

      {/* Active filter chips + counts */}
      <div className="d-flex justify-content-between gap-2 p-2 align-items-start">
        {filterCount > 0 && (
          <div className="d-flex align-items-center gap-2 mb-3 flex-wrap px-1">
            <span
              className="fw-semibold small text-uppercase"
              style={{ letterSpacing: 0 }}
            >
              Active
            </span>

            {activeChips.map((chip) => (
              <div
                key={chip.key}
                className="d-flex align-items-center gap-2 py-1 px-2 border rounded-pill bg-white filter-chip"
                style={{ fontSize: 13 }}
              >
                <span className="text-muted">{chip.labelKey}:</span>
                <span className="fw-bold text-dark">{chip.labelValue}</span>
                <IconX
                  size={14}
                  role="button"
                  onClick={chip.clear}
                  style={{ cursor: "pointer", color: "#6c757d" }}
                />
              </div>
            ))}

            <Button
              variant="link"
              size="sm"
              className="clear-all-btn text-decoration-none"
              onClick={handleClearFilter}
            >
              Clear all
            </Button>
          </div>
        )}

        <div
          className="d-flex align-items-center mb-2 px-1 text-muted fw-semibold"
          style={{ fontSize: "14px" }}
        >
          {(() => {
            const isActivelyFiltered = !!(
              search ||
              salesHeadFilter ||
              contractFilter ||
              orderTypeFilter ||
              paymentTypeFilter ||
              stageFilter ||
              (subStatusesFilter && subStatusesFilter.length > 0) ||
              vendorFilter ||
              (selectedProductsFilter && selectedProductsFilter.length > 0) ||
              fulfillmentFrom ||
              warehouseFrom ||
              startDate ||
              endDate
            );
            return isActivelyFiltered ? (
              <>
                <span className="text-orange me-1">{filteredTotal}</span> of{" "}
                {globalTotal} ORDERS MATCH
              </>
            ) : (
              <>SHOWING ALL {globalTotal} ORDERS</>
            );
          })()}
        </div>
      </div>

      {/* Views — both consume the same lifecycleData / filters */}
      {isListView ? (
        // <TableListing
        //   data={lifecycleData}
        //   limit={limit}
        //   loadingStates={loadingStates}
        //   hasMoreData={hasMoreData}
        //   onLoadMore={handleLoadMore}
        //   onRefresh={() => setIsSearchClicked(true)}
        // />
        <TableListingNew
          data={lifecycleData}
          limit={limit}
          loadingStates={loadingStates}
          hasMoreData={hasMoreData}
          onLoadMore={handleLoadMore}
          onRefresh={() => setIsSearchClicked(true)}
        />
      ) : (
        <div className="board-container">{renderLifecycleStages()}</div>
      )}
    </>
  );
};

export default LifeCycleListing;